import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import React from 'react';

const options = {
  renderNode: {
    [INLINES.HYPERLINK]: (node: any, children: any) => (
      <a className="marqueeLink" href={node.data.uri} rel="noreferrer">
        {children}
      </a>
    ),
  },
};

export const createRichTextMarqueeBanner = (content: any) => {
  return documentToReactComponents(content?.json, options);
};
